
{
  "fr": {
    "configuratorEditorThemePickerButton": {
      "useCustomTheme": "Choisir parmi nos 750+ modèles à personnaliser",
      "replaceCustomTheme": "Changer mon visuel"
    }
  }
}
